import React from "react";
import { InputLabel, Stack, FormControl, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import { StyledBox, StyledTypography } from "../style.module";
import { Controller, useFormContext } from "react-hook-form";

const FormCheckbox = ({
  name,
  elementId,
  inputLabel,
  isRequired,
  data = [],
  isDisabled,
  labelFontSize = "0.8rem",
  labelColor = "#000000",
  selectedField = []
}) => {
  const master_data = Array.isArray(data) ? data : [];
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Stack>
      <InputLabel htmlFor={elementId}>
        <StyledBox>
          {isRequired && (
            <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "red" }}>
              *
            </StyledTypography>
          )}
          <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "#000000", fontSize: "0.8rem" }}>
            {inputLabel}
          </StyledTypography>
        </StyledBox>
      </InputLabel>

      <FormControl component="fieldset" disabled={isDisabled}>
        <FormGroup row>
          <Controller
            control={control}
            name={name}
            defaultValue={[]}
            render={({ field }) => (
              master_data.map((option) => (
                <FormControlLabel
                  key={option.id}
                  control={
                    <Checkbox
                      disabled={isDisabled || option.disabled}
                      checked={(field.value ? field.value : []).some(item => item.id === option.id)}
                      onChange={(e) => {
                        let selectedValues = field.value ? [...field.value] : [];

                        if (e.target.checked) {
                          selectedValues.push(option);
                        } else {
                          selectedValues = selectedValues.filter(item => item.id !== option.id);
                        }
                        field.onChange(selectedValues);
                      }}
                      name={option.label}
                    />
                  }
                  label={
                    <StyledTypography
                      variant="body2"
                      sx={{ fontSize: labelFontSize, color: labelColor }}
                    >
                      {option.label}
                    </StyledTypography>
                  }
                />
              ))
            )}
          />
        </FormGroup>
        {errors[name] && (
          <StyledTypography variant="caption" color="error">
            {errors[name].message}
          </StyledTypography>
        )}
      </FormControl>
    </Stack>
  );
};

export default FormCheckbox;
